import { render, staticRenderFns } from "./warehouse-outputs.vue?vue&type=template&id=023a6237&scoped=true"
import script from "./warehouse-outputs.vue?vue&type=script&lang=js"
export * from "./warehouse-outputs.vue?vue&type=script&lang=js"
import style0 from "./warehouse-outputs.vue?vue&type=style&index=0&id=023a6237&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023a6237",
  null
  
)

export default component.exports